function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import apiCall from './apiCall';
export var TRANSLATE_CHANGE_LOCALE = 'TRANSLATE_CHANGE_LOCALE';
export var TRANSLATE_UPDATE_MESSAGES = 'TRANSLATE_UPDATE_MESSAGES';
/**
* Action for changing locale to display
* @param {String}  locale name of locale
* @return {Object}        declared action
*/

export function changeLocale(locale) {
  return {
    type: TRANSLATE_CHANGE_LOCALE,
    value: locale
  };
}
/**
* Action for updating locale messages
* @param {Object}  messages format options
* @return {Object}          declared action
*/

export function updateMessages(messages) {
  return {
    type: TRANSLATE_UPDATE_MESSAGES,
    value: messages
  };
}
/**
* Action for updating locale messages
* @param {Object}  config configuration options
* @return {Object}        declared action
*/

export function fetchTranslations(config) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getPromise = /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiCall(config, 'get', 'translations');
              case 2:
                data = _context.sent;
                dispatch(updateMessages(data));
                return _context.abrupt("return", data);
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      return function getPromise() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      type: 'TRANSLATE_FETCH_MESSAGES',
      payload: {
        promise: getPromise()
      }
    };
  };
}